module.exports = __webpack_public_path__ + "img/17.c6379b67.svg";